import React from 'react';

/**
 * Agnostic pill / cartouche.
 *
 * Props:
 *  - tone: 'blue' | 'green' | 'amber' | 'violet' | 'slate' | 'gray'
 *  - dot: boolean — render a leading colored dot
 *  - children: label content
 *  - className: extra classes
 */
const TONES = {
  blue: { wrap: 'text-[#3d5a8a] dark:text-blue-200 bg-[#e6f0ff] dark:bg-blue-900/40', dot: '#2f6df0' },
  green: { wrap: 'text-[#15784c] dark:text-green-200 bg-[#e2f5ea] dark:bg-green-900/40', dot: '#16a866' },
  amber: { wrap: 'text-[#8a6213] dark:text-amber-200 bg-[#fdf0d8] dark:bg-amber-900/40', dot: '#f5a623' },
  violet: { wrap: 'text-[#4a2fb0] dark:text-violet-200 bg-[#ece8fd] dark:bg-violet-900/40', dot: '#5b3df0' },
  slate: { wrap: 'text-[#3a4a63] dark:text-slate-200 bg-[#e8edf4] dark:bg-slate-700/50', dot: '#3a4a63' },
  gray: { wrap: 'text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700/60', dot: '#9ca3af' },
};

// Lets consumers drawing their own dot read the tone colour instead of copying hexes.
export const toneDot = (tone) => (TONES[tone] || TONES.gray).dot;

const Badge = ({ tone = 'gray', dot = false, children, className = '' }) => {
  const t = TONES[tone] || TONES.gray;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${t.wrap} ${className}`}>
      {dot && <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: t.dot }} aria-hidden />}
      {children}
    </span>
  );
};

export default Badge;
